import React from 'react';
import {
  Create,
  DisabledInput,
  Edit,
  List,
  NumberField,
  SimpleForm,
  TextField,
  TextInput,
  UrlField
} from 'react-admin';
import IconButton from '@material-ui/core/IconButton';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';

import { defaultListProps } from '~constants/config';
import CustomDatagrid from '~components/CustomDatagrid';
import ActionsField from '~components/ActionsField';
import FieldGroup from '~components/FieldGroup';
import api from '~config/api';
import { isRequired } from '~utils/inputValidations';

// The links under "Estudios" in the public menu, shown there in this list's order.

function MoveButtons({ record }) {
  const handleMove = direction => {
    api.post(`/studies/${record.id}/${direction}/`).then(() => {
      window.location.reload();
    });
  };

  return (
    <>
      <IconButton size="small" onClick={e => { e.stopPropagation(); handleMove('move-up'); }}>
        <ArrowUpward fontSize="small" />
      </IconButton>
      <IconButton size="small" onClick={e => { e.stopPropagation(); handleMove('move-down'); }}>
        <ArrowDownward fontSize="small" />
      </IconButton>
    </>
  );
}

function EstudioForm({ children, ...props }) {
  return (
    <SimpleForm {...props}>
      {children}
      {/* A link per language: the menu opens the one for the language the visitor chose. */}
      <FieldGroup label="fieldGroups.estudioEs">
        <TextInput source="titleEs" validate={isRequired} />
        <TextInput source="urlEs" type="url" validate={isRequired} fullWidth />
      </FieldGroup>
      <FieldGroup label="fieldGroups.estudioEn">
        <TextInput source="titleEn" />
        <TextInput source="urlEn" type="url" fullWidth />
      </FieldGroup>
      <FieldGroup label="fieldGroups.estudioPt">
        <TextInput source="titlePt" />
        <TextInput source="urlPt" type="url" fullWidth />
      </FieldGroup>
    </SimpleForm>
  );
}

export function EstudioList(props) {
  return (
    <List {...defaultListProps} {...props} sort={{ field: 'order', order: 'ASC' }}>
      <CustomDatagrid rowClick="edit">
        <NumberField source="order" sortable={false} />
        <TextField source="titleEs" sortable={false} />
        <UrlField source="urlEs" sortable={false} target="_blank" onClick={e => e.stopPropagation()} />
        <MoveButtons label="Orden" />
        <ActionsField />
      </CustomDatagrid>
    </List>
  );
}

export function EstudioCreate(props) {
  return (
    <Create {...props}>
      <EstudioForm redirect="list" />
    </Create>
  );
}

export function EstudioEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <EstudioForm redirect="list">
        <DisabledInput label="Id" source="id" />
      </EstudioForm>
    </Edit>
  );
}
